import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["count", "icon", "highlightIcon", "title"];
import React from 'react';
import Icon from 'components/Icon';
import { TooltipPill } from 'components/Pill';
export function TooltipPillWithCount(props) {
  var count = props.count,
    icon = props.icon,
    highlightIcon = props.highlightIcon,
    title = props.title,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(TooltipPill, _extends({}, otherProps, {
    title: title,
    icon: highlightIcon ? icon : undefined
  }), !highlightIcon && icon && /*#__PURE__*/React.createElement(Icon, {
    vAlign: true,
    dimmed: true,
    name: icon,
    scale: 0,
    mr: "xxs"
  }), count);
}
export default TooltipPillWithCount;